$('.ua-touch [data-toggle="popover"]:not([data-trigger])').popover({trigger: 'focus'});
$('.ua-no-touch [data-toggle="popover"]:not([data-trigger])').popover({trigger: 'hover'});
